function getNdConfig() {
    if (typeof window === 'undefined' || !window.ND_CONFIG) {
        return {};
    }
    return window.ND_CONFIG;
}

function getMapProviderConfig() {
    return getNdConfig().mapProviders || {};
}

function getConfiguredValue(key) {
    const value = getMapProviderConfig()[key];
    return typeof value === 'string' ? value : '';
}

function buildMapboxTileUrl(style = 'mapbox/satellite-v9') {
    const token = getConfiguredValue('mapboxAccessToken');
    const tokenQuery = token ? `?access_token=${encodeURIComponent(token)}` : '';
    return `https://api.mapbox.com/styles/v1/${style}/tiles/256/{z}/{x}/{y}${tokenQuery}`;
}

export {
    buildMapboxTileUrl,
    getConfiguredValue,
    getMapProviderConfig,
};
